import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import { scrollToId } from "@/lib/api";
import { euro } from "@/hooks/useQuote";

export const StickyBookingBar = ({ property, booking, quote }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hasDates = Boolean(booking.checkIn && booking.checkOut);
  const showTotal = hasDates && quote?.available && quote?.total != null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-booking-bar"
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 shadow-[0_-12px_30px_-18px_rgba(28,27,26,0.4)] backdrop-blur-xl md:hidden"
        >
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="flex items-baseline gap-1" data-testid="sticky-bar-price">
                <span className="font-display text-xl font-extrabold text-clay">
                  {showTotal ? euro(quote.total) : `${property?.price_per_night ?? 90} €`}
                </span>
                <span className="text-xs font-medium text-fog">
                  {showTotal ? `· ${quote.nights} ${quote.nights === 1 ? "noite" : "noites"}` : "/ noite"}
                </span>
              </p>
              <p className="truncate text-[11px] text-fog" data-testid="sticky-bar-note">
                {hasDates
                  ? quote?.available === false
                    ? "Datas ocupadas — escolha outras"
                    : "Sem pagamento online"
                  : "Escolha as datas no pedido"}
              </p>
            </div>
            <button
              type="button"
              data-testid="sticky-bar-reserve-btn"
              onClick={() => scrollToId("reservar")}
              className="flex shrink-0 items-center gap-2 rounded-full bg-clay px-6 py-3 text-sm font-bold text-white transition-[transform,background-color] duration-300 active:scale-[0.97]"
            >
              <CalendarDays size={15} /> Reservar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
